<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить запись</span>
              <span v-else> <div>Добавить запись</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <loading-autocomplete
              placeholder="Введите ФИО и выберете из предложенных вариантов"
              label="Сотрудник"
              v-model="value.worker"
              search-parameter="fio"
              :post-loader="postLoader"
              :url="department_selector"
              :error="hasError('worker')"
              :errorMessages="getError('worker')"
            >
              <template v-slot:no-data>
                <div>
                  Для поиска начните набирать ФИО, <br> и либо остановитесь на 1 секунду, либо нажмите Enter
                </div>
              </template>
            </loading-autocomplete>
            <v-autocomplete
              :error="hasError('role')"
              :error-messages="getError('role')"
              :items="choices.role"
              label="Роли"
              v-model="value.role"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('dissertationCouncil')"
              :error-messages="getError('dissertationCouncil')"
              :items="selectors.dissertationCouncil"
              label="Диссертационный совет"
              v-model="value.dissertationCouncil"
              no-data-text ="Нет данных"
            ></v-autocomplete>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import urls from "../../../../../modules/petition/urls"
  import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
  import {makeGetRequest,makePostRequest} from "../../../../../helper";
  import urlsW from "../../../../../modules/petition/urlsW.js"
  import urlsU from "../../../../../modules/petition/urlsU.js"
  import {generateListUidToName} from "@/helper/uidToName";
  import LoadingAutocomplete from "@/modules/core/components/LoadingAutocomplete";

  export default {
    name: "Role",
    mixins: [UserDataFormMixin],
    props: [ 'id', 'worker', 'role','dissertationCouncil',],
    components: {
      LoadingAutocomplete
    },
    computed: {
      department_selector(){
        return urlsW.getUrl('selectors|employee|worker', 'get')
      },
    },
    data() {
      return {
        URL_CREATE: urls.getUrl('admin|permissions|models|role_worker-list', 'create'),
        URL_UPDATE:  urls.getUrl('admin|permissions|models|role_worker-detail', 'update'),

        value: {
          id: this.id || '',
          worker:this.worker || '',
          role:this.role || null,
          dissertationCouncil:this.dissertationCouncil || '',
        },
        choices:{
          role:[]
        },
        selectors:{
          dissertationCouncil:[],
        },
      }
    },
    methods: {
      postLoader(data, list, end) {
        data.results.forEach(el => {
          this.$set(el, 'fio', '');
        })
        let vals = list(data.results);
        generateListUidToName(
          vals,
          "value",
          "fio",
          ()=>{
            vals.forEach(el => {
              this.$set(el, 'text', `${el.fio}, ${el.text}`)
            })
            end();
          }
        )
      },
      loadSelector(data,url){
        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }) .then(json => {
          this.selectors[data] = json
        })
      },
      closeDialog() {
        this.$emit('ended', '')
      },
    },
    created() {
      let url =  urls.getUrl('admin|diss|selectors|dissertation_council', 'get')
      this.loadSelector("dissertationCouncil",url)

      let role_choices = urls.getUrl('admin|permissions|choices|role_choices', 'get')
      let sys = true
      makeGetRequest(role_choices).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        this.choices.role= json
      })
    }
  }

</script>

<style scoped>

</style>
